<div class="pt-4">
  <p class="mb-4 mt-5 font-accent text-md font-bold md:mt-6">
    {{ title }}
    @if (required) {
      <span>&#42;</span>
    }
  </p>

  <div class="flex flex-col gap-1">
    <app-block-list
      [blockIdList]="options"
      [injectData]="{ parentId: blockId }"
    ></app-block-list>
  </div>
</div>
